export default "/images/510c1b8943911ab50b932422c1cbfb89.avif";